module.exports = __webpack_public_path__ + "img/watch.b3d28e67.svg";